export default {
  apiPath: 'http://localhost:5075/api',
  enableDevMode: true,
};
